<div class="wrapper" appMousemove>
  <app-scroll-to-top-btn></app-scroll-to-top-btn>
  <app-navigation></app-navigation>
  <div class="wrapper-container">
    <div class="container">
      <section class="how-to-ride">
        <div class="country-breadcrumbs">
          <a href="" class="country-breadcrumb">
            BusyFly /
          </a>
          <div class="country-breadcrumb">
            Как кататься
          </div>
        </div>
        <div class="how-to-ride__body">
          <div class="section-title">
            Правила вождения&nbsp;СИМ
          </div>
          <div class="images-container">
            <img src="../../assets/img/driving-rules/driving-rules-ru/driving-rules-ru_1.webp" alt="img">
            <img src="../../assets/img/driving-rules/driving-rules-ru/driving-rules-ru_2.webp" alt="img">
            <img src="../../assets/img/driving-rules/driving-rules-ru/driving-rules-ru_3.webp" alt="img">
            <img src="../../assets/img/driving-rules/driving-rules-ru/driving-rules-ru_4.webp" alt="img">
            <img src="../../assets/img/driving-rules/driving-rules-ru/driving-rules-ru_5.webp" alt="img">
            <img src="../../assets/img/driving-rules/driving-rules-ru/driving-rules-ru_6.webp" alt="img">
            <img src="../../assets/img/driving-rules/driving-rules-ru/driving-rules-ru_7.webp" alt="img">
            <img src="../../assets/img/driving-rules/driving-rules-ru/driving-rules-ru_8.webp" alt="img">
            <img src="../../assets/img/driving-rules/driving-rules-ru/driving-rules-ru_9.webp" alt="img">
          </div>
        </div>
      </section>
    </div>
  </div>
  <app-info></app-info>
  <app-footer></app-footer>
</div>
